import { createAsyncReducer } from '../../standard-actions/';
import {
    IUpdateDirectDebitDetailAction,
    IUpdateDirectDebitDetailSuccessAction,
    IUpdateDirectDebitDetailErrorAction
} from '../actions/update-direct-debit-details';
import { IBillingState } from '../state';
import { initialState } from '../state/initial-state';

export type UpdateDirectDebitAction
    = IUpdateDirectDebitDetailAction
    | IUpdateDirectDebitDetailSuccessAction
    | IUpdateDirectDebitDetailErrorAction;

const init = (state: IBillingState, action: UpdateDirectDebitAction) => ({
    ...state,
    updateDirectDebitDetail: {
        ...state.updateDirectDebitDetail,
        status: action.status
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

const success = (state: IBillingState, action: UpdateDirectDebitAction) => ({
    ...state,
    updateDirectDebitDetail: {
        status: action.status,
        data: (action as IUpdateDirectDebitDetailSuccessAction).data
    },
    showToast: {
        type: 'update',
        visible: true,
        text: 'Direct debit updated'
    }
});

const failure = (state: IBillingState, action: UpdateDirectDebitAction) => ({
    ...state,
    updateDirectDebitDetail: {
        ...initialState.updateDirectDebitDetail,
        status: action.status,
        error: (action as IUpdateDirectDebitDetailErrorAction).error,
        errorCode: (action as IUpdateDirectDebitDetailErrorAction).errorCode
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

const notStarted = (state: IBillingState, action: UpdateDirectDebitAction) => ({
    ...state,
    updateDirectDebitDetail: {
        status: action.status,
        data: null
    },
    showToast: {
        type: '',
        visible: false,
        text: ''
    }
});

export const updateDirectDetailReducer = createAsyncReducer(initialState, init, success, failure, notStarted);
